module.exports = __webpack_public_path__ + "static/media/XinZhao_0.f9ba83de.png";